import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { Route } from 'react-router';
import { OrderSearch } from './OrderSearch'
import { SessionTimedOut } from './SessionTimedOut';
import { ChangePassword } from './ChangePassword';

import { DocumentContent } from './DocumentContent';
import { CreditContent } from './CreditContent';
import { Product } from './Products';
import { Login } from './Login';
import { CheckOut } from './CheckOut';
import { SavedCarts } from './SavedCarts';
import { InvoiceOrderSearch } from './InvoiceOrderSearch';
import { Budget } from './Budget'
import { AdminUser } from './AdminUser'
import { Users } from './Users';
import { ClearCartPrompt } from './ClearCartPrompt';
import { OrderApproval } from './OrderApproval';
import { DocumentsManage } from './DocumentsManage';
import { AdminManage } from './AdminManage';

export class OrderApprovalHistory extends Component {
    displayName = OrderApprovalHistory.name

    constructor(props) {
        super(props);

        this.state = {
            approvalHistoryList: [],
            loadingOrders: false,
            orderHeader: {},
            toChangePassword: false,
            menuVisibility: 'hidden',
            loadingHeader: false,
            orderDate: '',
            orderId: '',
            deliveryDate: '',
            userDetails: {},
            ToList: false,

            ToOrderDocument: false,
            toCheckOut: false,
            toSaveCart: false,
            toManage: false,
            toDocuments: false,
            toOrderForm: false,
            toAdmin: false,
            toLogIn: false,
            toBudgets: false,
            toOrderSearch: false,
            toOrderApproval: false,
            toClearCartPrompt: false,
            toSavedCarts: false,
            isAdminVisibile: 'hidden',
            canTrack: 'hidden',
            ApproveVisibility: 'hidden',
            toProducts: false,
            toOrderApprovalButtonVisibility: 'hidden',
            toOrderSearchButtonVisibility: 'hidden',
            toOrderApprovalButtonWidth: '0%',
            toOrderSearchButtonWidth: '0%',
            declineVisibility: 'hidden',
            toSessionTimedOut: false,
            toDocumentsManage: false,

        };

        this.CheckSessionInitialize();
    }

    CheckSessionInitialize() {
        this.setState({ complete_update: false });
        console.log('get CheckSession called');

        fetch('api/Login/CheckSession?buster=' + + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => {
                if (data == 'running') {
                    this.setState({ toSessionTimedOut: false });
                    this.GetPredecessor();
                    this.GetUserDetails();
                    this.GetApprovalHistoryOrderId();
                    this.GetApprovalHistoryList();
                    this.CheckIfAdmin();
                    this.CheckIfCanTrack();
                }
                else if (data == 'timedout'){
                    this.setState({ toSessionTimedOut: true });
                }
            });
    }

    CheckSession() {
        this.setState({ complete_update: false });
        console.log('get CheckSession called');

        fetch('api/Login/CheckSession?buster=' + + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => {
                if (data == 'running') {
                    this.setState({ toSessionTimedOut: false });
                }
                else if (data == 'timedout'){
                    this.setState({ toSessionTimedOut: true });
                }
            });
    }

    GetPredecessor() {
        fetch('/api/InvoiceOrder/GetOrderContentPredecessor' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => {
                if (data == 'OA') {
                    this.setState({
                        toOrderApprovalButtonVisibility: 'visible',
                        toOrderApprovalButtonWidth: '20%',
                        toOrderSearchButtonVisibility: 'hidden',
                        toOrderSearchButtonWidth: '0%',
                    });
                }
                else if (data == 'O') {
                    this.setState({
                        toOrderSearchButtonVisibility: 'visible',
                        toOrderSearchButtonWidth: '20%',
                        toOrderApprovalButtonVisibility: 'hidden',
                        toOrderApprovalButtonWidth: '0%',
                    });
                }
            })

    } 

    CheckIfAdmin() {
        fetch('/api/Login/isAdmin' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => { this.setState({ isAdminVisibile: (data == 'Y' ? 'visible' : 'hidden') }, () => { console.log('visibility : data=' + data + ' value= ' + this.state.isAdminVisibile); }) })
    }

    PrintOrder() {
        fetch('api/InvoiceOrder/PrintOrder?&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then((output) => {
                const url = "data:application/pdf;base64," + output;
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'file.pdf');
                document.body.appendChild(link);
                link.click();
            });
    }

    InvoiceCredits() {
        this.setState({ ToList: true });
    }

    GetOrder() {
        this.setState({ loadingHeader: true });
        console.log('loading ordrer ');

        fetch('/api/InvoiceOrder/GetCurrentOrder' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => { this.setState({ orderHeader: data, loadingHeader: false, orderDate: data.orderDate, deliverDate: data.deliveryDate }, console.log(data)) })
            .then(() => {
                console.log("order");
                console.log(this.state.orderHeader);

                if (this.state.orderHeader.orderStatus == 'declined') {
                    this.setState({ declineVisibility: 'visible' });
                }
            })
    }

    GetApprovalHistoryList() {
        this.setState({ loadingOrders: true });
        console.log('loading order item list');

        fetch('/api/InvoiceOrder/GetApprovalHistoryDetails' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => { this.setState({ approvalHistoryList: data, loadingOrders: false }) });
    }

    GetApprovalHistoryOrderId() {

        fetch('/api/InvoiceOrder/GetApprovalHistoryOrderId' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => { this.setState({ orderId: data }) });
    }

    LoadApprovalOrderItems() {

        if (this.state.loadingOrders) {
            return (
                <tr>
                    <td>loading...</td>
                    <td>loading...</td>
                    <td>loading...</td>
                    <td>loading...</td>
                    <td>loading...</td>
                    <td>loading...</td>
                </tr>
            );

        }
        else {
            return (
                this.state.approvalHistoryList.map(approvalHistoryItem =>
                    <tr style={{ lineHeight: '1px' }}>
                        <td style={{ textAlign: 'left' }}>{approvalHistoryItem.approverName}</td>
                        <td style={{ textAlign: 'left' }}>{approvalHistoryItem.status}</td>
                        <td className="sideBorder overflow_table" style={{ textAlign: 'left', maxWidth: '250px' }}>{approvalHistoryItem.reason}</td>
                        <td style={{ textAlign: 'left' }}>{approvalHistoryItem.notification}</td>
                        <td style={{ textAlign: 'left' }}>{approvalHistoryItem.escalation}</td>
                    </tr>
                ));
        }

    }

                        //<td style={{ textAlign: 'left' }}>{approvalHistoryItem.approverType}</td>

    ToChangePassword() {
        fetch('/api/Login/CanUpdatePassword' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(response => {

                if (response == 'true')
                    this.setState({ toChangePassword: true });
                else
                    alert('You currently do not have the required permissions to change your password.');

            });
    }

    MenuClick() {

        if (this.state.menuVisibility == 'hidden') {
            this.setState({ menuVisibility: 'visible' });
        }
        else if (this.state.menuVisibility == 'visible') {
            this.setState({ menuVisibility: 'hidden' });
        }
    }

    render() {

        //Route Changers
        if (this.state.toSessionTimedOut) {
            return <Route path='/' component={SessionTimedOut} />
        }

        if (this.state.toAdmin) {
            return <Route path='/' component={AdminManage} />
        }


        if (this.state.GoToOrderSearch) {
            return <Route path='/' component={OrderSearch} />
        }

        if (this.state.toChangePassword) {
            return <Route path='/' component={ChangePassword} />

        }


        if (this.state.toBudgets) {
            return <Route path='/' component={Budget} />
        }

        if (this.state.toSavedCarts) {
            return <Route path='/' component={SavedCarts} />
        }

        if (this.state.toCheckOut) {
            return <Route path='/' component={CheckOut} />
        }

        if (this.state.toDocuments) {
            return <Route path='/' component={InvoiceOrderSearch} />
        }

        if (this.state.toDocumentsManage) {
            return <Route path='/' component={DocumentsManage} />
        }

        if (this.state.toLogIn) {
            return <Route path='/' component={Login} />
        }

        if (this.state.toProducts) {
            return <Route path='/' component={Product} />
        }

        if (this.state.ToCreditDocument) {
            return <Route path='/' component={CreditContent} />
        }

        if (this.state.ToDocument) {
            return <Route path='/' component={DocumentContent} />
        }



        if (this.state.toOrderApproval) {
            return <Route path='/' component={OrderApproval} />
        }

        if (this.state.toClearCartPrompt) {
            return <Route path='/' component={ClearCartPrompt} />
        }

        if (this.state.ToList) {
            return <Route path='/' component={OrderSearch} />
        }

        let approvalHistoryList = this.LoadApprovalOrderItems();

        return (
            <div style={{ width: "100%", height: "100%", color: 'black' }}>
                <div className="header" style={{ position: 'fixed', zIndex : '500'}}>
                    <div className="grid_container_header" style={{ msHyphens: 'auto', display: 'inline-grid', gridTemplateColumns: '30% 40% 30%', display: 'grid -ms-grid', msGridColumns: '30% 40% 30%', columnCount: '3' }}>
                        <div className="grid_header">
                            <div className="icon_home" style={{ width: '100%', height: '50%', 'margin-top': '30px', 'margin-left': '10%', float: 'left', 'background-repeat': 'no-repeat' }}></div>
                        </div>
                        <div className="grid_header" style={{ 'text-align': 'left', overflow: 'hidden' }}>
                            <div className="header_container" style={{ width: '100%' }}>
                                <div>

                                    <div style={{ display: 'inline' }}>
                                        <a className="header_text" onClick={() => this.GoBackToProducts()}  >Place Order</a>|
                                                <a className="header_text" onClick={() => this.GoToDocumentsManage()} >Documents</a><span style={{ visibility: this.state.canTrack }}>|</span>
                                        <a className="header_text" onClick={() => this.GoToOrderApproval()} style={{ visibility: this.state.canTrack }} >Order Approval</a>
                                        <span style={{ visibility: 'visible' }}>|</span>
                                        <a className="header_text" onClick={() => this.GoToBudget()} style={{ visibility: 'visible' }}>Budgets</a>
                                        <span style={{ visibility: this.state.isAdminVisibile }}>|</span>
                                        <a className="header_text" onClick={() => this.GoToAdmin()} style={{ visibility: this.state.isAdminVisibile }} >Admin</a>
                                    </div>
                                </div> 

                            </div>
                        </div>
                        <div className="grid_header">
                            <div className="header_container greeting" style={{ width: '100%' }}>
                                <div className="header_text grid_item_1" style={{ lineHeight: '40px', textAlign: 'right' }}>
                                    <div style={{ height: '28px' }} className="overflow_header"> {this.state.userDetails.greeting + ', ' + this.state.userDetails.fullname}</div>
                                    <div style={{ height: '25px' }} className="overflow_header">{this.state.userDetails.accountName}</div>
                                    <div style={{ height: '28px' }} className="overflow_header">Group : {this.state.userDetails.accountCode}</div>
                                </div>
                                <div className="grid_item_2_reverse  h100">
                                    <div style={{ width: '100%', 'height': '100%' }}>
                                        <button id="btnMenu" onClick={() => this.MenuClick()} className="btn primary_btn header_btn twfont" style={{ lineHeight: '0.8', marginTop: '10px'  }}  ><i className="material-icons" style={{ width: '100%' }} >menu</i><label>Options</label></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header_menu_container" style={{ visibility: this.state.menuVisibility }}>
                    <div className="grid_item_1 max-height-menu">
                        <button onClick={() => { this.MenuClick() }} style={{ width: '100%', height: '100%', backgroundColor: 'transparent', border: 'none' }}></button>
                    </div>
                    <div className="header_menu grid_item_2 max-height-menu customer_background_foreground">
                        <hr />
                        <div>
                            <button id="canUpdateBtn" name="canUpdateBtn" className="btn  header_menu_item" onClick={() => { this.ToChangePassword() }}>Reset Password <i className="material-icons" style={{ position: 'relative', top: '6px', paddingLeft: '10px' }}>vpn_key</i></button>
                        </div>
                        <hr />
                        <div>
                            <button className="btn  header_menu_item" onClick={() => { this.GetCartState() }}>Logout <i className="material-icons" style={{ position: 'relative', top: '6px', paddingLeft: '10px' }}>exit_to_app</i></button>
                        </div>
                        <hr />
                    </div>
                </div>
                <div className="CssPageContatiner" style={{ padding: '2%' }}>
                    <div>
                        <button ID="btnBackO" className="btn secondary_btn" style={{ width: this.state.toOrderSearchButtonWidth, 'font-family': 'Tw Cen MT', visibility: this.state.toOrderSearchButtonVisibility }} onClick={() => this.GoToOrderSearch()}>Back to Orders</button >
                        <button ID="btnBackOA" className="btn secondary_btn" style={{ width: this.state.toOrderApprovalButtonWidth, 'font-family': 'Tw Cen MT', visibility: this.state.toOrderApprovalButtonVisibility }} onClick={() => this.GoToOrderApproval()}>Back to Order Approval</button >

                        <br />
                        <br />
                    </div>
                    <div id="Page" className="CssPage">
                        <div className="pageContainer" style={{ display: 'inline-grid', gridTemplateColumns: '100%', padding: '30px', fontFamily: 'Tw Cen MT' }}>
                            <div className="pageContainer" style={{ backgroundColor: 'white', paddingRight: '30px', height: '100%' }}>
                                <div style={{ borderBottom: 'solid', marginBottom: '0' }}>
                                    <label style={{ fontSize: 'xx-large', fontWeight: 'bolder', paddingTop: '15px', marginBottom: '0' }}>Approval history for order {this.state.orderId} </label>
                                </div>
                                <div style={{ height: '87%', width: '100%', backgroundColor: 'white', marginTop: '20px' }}>
                                    <div style={{ backgroundColor: 'white', height: '1%' }}>
                                    </div>
                                    
                                    <div style={{ height: '55%', backgroundColor: 'white' }}>
                                        <table className="table " style={{ fontFamily: 'TW Cen MT', width: '100%',overflow: 'scroll', maxHeight: '350px' }}>
                                            <thead style={{ lineHeight: '1px', borderBottom: 'solid' }}>
                                                <th style={{ textAlign: 'left' }}>Name</th>
                                                <th style={{ textAlign: 'left' }}>Approval Status</th>
                                                <th style={{ textAlign: 'left' }}>Reason</th>
                                                <th style={{ textAlign: 'left' }}>Last Notification Time</th>
                                                <th style={{ textAlign: 'left' }}>Escalation/Approval/Decline Time</th>
                                            </thead>
                                            {approvalHistoryList}
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    ///Global methods

    GetCartState() {

        fetch('/api/Product/GetCartCount' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => {
                if (data == "valued") {
                    this.setState({ toClearCartPrompt: true });
                } else {
                    window.location.href = '\\';
                }
            });
    }

    CheckIfAdmin() {
        fetch('/api/Login/isAdmin' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => { this.setState({ isAdminVisibile: (data == 'Y' ? 'visible' : 'hidden') }, () => { console.log('visibility : data=' + data + ' value= ' + this.state.isAdminVisibile); }) })
    }

    GoToDocumentsManage() {
        this.setState({ toDocumentsManage: true });
    }


    GoToOrderSearch() {
        this.setState({ GoToOrderSearch: true });
    }


    GoToOrderApproval() {
        this.setState({ toOrderApproval: true });
    }

    GoToDocuments() {
        this.setState({ toDocuments: true });
    }

    toOrderForm() {
        this.setState({ toOrderForm: true });
    }

    GoToLogIn() {
        this.setState({ toLogIn: true });
    }

    GoToAdmin() {
        this.setState({ toAdmin: true });
    }

    GoBackToProducts() {
        this.setState({ toProducts: true });
    }

    GoToBudget() {
        this.setState({ toBudgets: true });
    }

    GoToOrderForm() {
        this.setState({ toOrderForms: true });
    }

    GoToOrderSearch() {
        this.setState({ GoToOrderSearch: true });
    }


    GoToSavedCarts() {
        this.setState({ toSavedCarts: true });
    }

    GetUserDetails() {
        fetch('api/Login/GetUserDetails' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => { this.setState({ userDetails: data }) })
            .then(() => {
                console.log("user details");
                console.log(this.state.userDetails);
            })
    }



    CheckIfCanTrack() {
        fetch('/api/Login/canTrack' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => { this.setState({ canTrack: (data == 'Y' ? 'visible' : 'hidden') }, () => { console.log('visibility : data=' + data + ' value= ' + this.state.isAdminVisibile); }) })
    }
}

//<button ID="btnPrint" className="btn tertiary_btn" style={{ 'font-family': 'Tw Cen MT', width: '20%' }} onClick={() => this.PrintOrder()}>Print</button >